module.exports = __webpack_public_path__ + "static/media/NASW-NJ video script draft 2021_1639073355520.ca2a4246. JT EDITS 11";